import actions from './testsActions'
import mutations from './testsMutations'

export default {
  namespaced: true,
  actions,
  mutations
}
